import { render, staticRenderFns } from "./MyCollectTask.vue?vue&type=template&id=3cedc33a&scoped=true"
import script from "./MyCollectTask.vue?vue&type=script&lang=js"
export * from "./MyCollectTask.vue?vue&type=script&lang=js"
import style0 from "./MyCollectTask.vue?vue&type=style&index=0&id=3cedc33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cedc33a",
  null
  
)

export default component.exports